

import {  Link } from "react-router-dom"
   import ErrorCom from '../../core/AbodeErrorTag'
  import SVAbodeSpinner from '../../core/SVAbodeSpinner';

   import Terrain from '../../terrain/Terrain'
   import GlassTerrain from '../../terrain/GlassTerrain'
   import MotelTerrain from '../../terrain/MotelTerrain'
   //import FacetBar from '../../esfind/FacetBar'
   import TerrainStars from '../../terrain/TerrainStars'
 
   import {FlySearchBarBusCom, SVFlyFacetBarBusCom} from '../../../containers'
   import FlySearchBar from '../../flyfind/FlySearchBar'

   import {SV_SOJ_ORCMOCK_ADDRESS} from '../../../constants'
   import { Icon, Button, Row, Col, Badge } from 'antd';

   import FlyLocationSVPriceListView from '../../terrain/FlyLocationSVPriceListView'
   import AmbLocationSVPriceListView from '../../amb/AmbLocationSVPriceListView'

   import AmbSVJourneyListView from '../../amb/AmbSVJourneyListView'
   import FlySearchBoardBody from './flyBoardBody'

import { v4 as uuidv4 } from 'uuid';
import history from "../../../history"

import '../../../css/svlist_styles.css'
const React = require('react')
const _ = require('lodash')



const promoDisabled = true
const HeartSvg = () => (
 <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
   <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
 </svg>
);

const HeartIcon = props => <Icon component={HeartSvg} {...props} />



class FlySearchBoardContainer extends React.Component {
    svofferMyFlyReservationSelectparent(valuesChild,flight_space_key, svcustProfile){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv  NOV19   1 cookie1 from AmbLocation callback  flyboard svofferMyFlyReservationSelectparent**********parent')
      console.log(valuesChild)
      console.log('^^^^^^^^^^^^ svcustProfile^^^^^^^^')
      console.log(svcustProfile)
      const { cookies } = this.props;
      if(cookies){
          let svcookoffer_o = null
          console.log('********NOV19**************** sv    2 COOKIES SET svcookoffer  svofferMyFlyReservationSelectparent START')
  
          if(valuesChild ){
            
             let svcid = svcustProfile.customerId
             console.log('********NOV19**************** sv customerId ', svcid)
              let svcustProfile_newcustomer = {
                "customerId": -6,
                "addressId":-1
            }
             if(!valuesChild['svcustProfile']){
                valuesChild['svcustProfile'] = svcustProfile_newcustomer
             }
              let svaluesChild = JSON.stringify(valuesChild)


            
              
              cookies.set('svcook', svaluesChild, { path: '/' });

              let m_offer = cookies.get('svcook')
              console.log('********OCT25**************** TEST TO COOKIES SET svcookoffer START', m_offer)
            
              let my_data_svtoffee ={
                "customerId": valuesChild['svcustProfile']['customerId'] ,
                "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
                "svcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
            } 
            my_data_svtoffee.svcook = svaluesChild
            
            let m_svt =  cookies.get('svt')
            if(m_svt != null){
                my_data_svtoffee['svt'] = m_svt
            }
            console.log('********DEC2**************** TEST TO COOKIES SET my_data_svtoffee ')
            console.log(my_data_svtoffee)

            this.props.saveUserOffer({'my_data_svtoffee' :my_data_svtoffee})
            
              
// /myflyreservationsSV/${svcid}/flyressvCustNew/${flight_space_key}
const udob ={
    "svcid": svcid,
    "flight_space_key":flight_space_key

}
_.delay(()=>{
    console.log('sv****calling myres delauy DEC3' )
    const {svcid, flight_space_key} = udob
    let svcusturl = `/myaccountSV/${svcid}/flyressvCustNew/${flight_space_key}`
    console.log(svcusturl)
    console.log('sv****calling myres delauy DEC3 END' )
    //history.push(svcusturl)
    history.push(`/myaccountSV/${svcid}/flyressvCustNew/${flight_space_key}`)
   //history.push(`/myflyreservationsSV/${svcid}/flyressvCustNew/${flight_space_key}`)
}, 1400, udob);


              //history.push(`/myflyreservationsSV/${svcid}/flyressvCustNew/${flight_space_key}`)
  
          }else{
              console.log('********OCT25**************** FAILED TO COOKIES SET svcookoffer START')
   
          }
          

      }

    }
    svofferselectparent(valuesChild,flight_space_key ){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv  OCT28  1 cookie1 from AmbLocation callback  flyboard svofferselectparent**********parent')
      console.log(valuesChild)
      const { cookies } = this.props;
    
     /*
      const { cookies , localStorage} = this.props;
     console.log('sv*** MARCH27SV localStorage start')
     console.log(localStorage)
     console.log('sv*** MARCH27SV localStorage end')
*/
      if(cookies){
          let svcookoffer_o = null
          console.log('********OCT25**************** sv  OCT28 2 COOKIES SET svcookoffer START')
  
          if(valuesChild ){
            let svcookoffer_val = {}
              /*
               svcookoffer_val = {
                  "type": "flight-offer",
                  "id": "2",
                  "source": "GDS",
                  "instantTicketingRequired": false,
                  "nonHomogeneous": false,
                  "oneWay": false,
                  "isUpsellOffer": false,
                  "lastTicketingDate": "2024-10-27",
                  "lastTicketingDateTime": "2024-10-27",
                  "numberOfBookableSeats": 3,
                  "itineraries": [
                      {
                          "duration": "PT9H15M",
                          "segments": [
                              {
                                  "departure": {
                                      "iataCode": "JFK",
                                      "terminal": "5",
                                      "at": "2024-11-01T12:10:00"
                                  },
                                  "arrival": {
                                      "iataCode": "BOS",
                                      "terminal": "C",
                                      "at": "2024-11-01T13:22:00"
                                  },
                                  "carrierCode": "B6",
                                  "number": "1318",
                                  "aircraft": {
                                      "code": "E90"
                                  },
                                  "operating": {
                                      "carrierCode": "B6"
                                  },
                                  "duration": "PT1H12M",
                                  "id": "1",
                                  "numberOfStops": 0,
                                  "blacklistedInEU": false
                              },
                              {
                                  "departure": {
                                      "iataCode": "BOS",
                                      "terminal": "C",
                                      "at": "2024-11-01T15:00:00"
                                  },
                                  "arrival": {
                                      "iataCode": "LAX",
                                      "terminal": "5",
                                      "at": "2024-11-01T18:25:00"
                                  },
                                  "carrierCode": "B6",
                                  "number": "387",
                                  "aircraft": {
                                      "code": "32S"
                                  },
                                  "operating": {
                                      "carrierCode": "B6"
                                  },
                                  "duration": "PT6H25M",
                                  "id": "2",
                                  "numberOfStops": 0,
                                  "blacklistedInEU": false
                              }
                          ]
                      }
                  ],
                  "price": {
                      "currency": "USD",
                      "total": "950.87",
                      "base": "861.67",
                      "fees": [
                          {
                              "amount": "0.00",
                              "type": "SUPPLIER"
                          },
                          {
                              "amount": "0.00",
                              "type": "TICKETING"
                          }
                      ],
                      "grandTotal": "950.87"
                  },
                  "pricingOptions": {
                      "fareType": [
                          "PUBLISHED"
                      ],
                      "includedCheckedBagsOnly": true
                  },
                  "validatingAirlineCodes": [
                      "B6"
                  ],
                  "travelerPricings": [
                      {
                          "travelerId": "1",
                          "fareOption": "STANDARD",
                          "travelerType": "ADULT",
                          "price": {
                              "currency": "USD",
                              "total": "950.87",
                              "base": "861.67"
                          },
                          "fareDetailsBySegment": [
                              {
                                  "segmentId": "1",
                                  "cabin": "ECONOMY",
                                  "fareBasis": "MI3AUEY5",
                                  "brandedFare": "AN",
                                  "brandedFareLabel": "BLUE",
                                  "class": "M",
                                  "includedCheckedBags": {
                                      "quantity": 2
                                  },
                                  "amenities": [
                                      {
                                          "description": "CHECKED BAG FIRST",
                                          "isChargeable": true,
                                          "amenityType": "BAGGAGE",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "CHECKED BAG SECOND",
                                          "isChargeable": true,
                                          "amenityType": "BAGGAGE",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "EXTRA LEGROOM",
                                          "isChargeable": true,
                                          "amenityType": "PRE_RESERVED_SEAT",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "ADVANCE SEAT SELECTION",
                                          "isChargeable": false,
                                          "amenityType": "PRE_RESERVED_SEAT",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "SNACK",
                                          "isChargeable": false,
                                          "amenityType": "MEAL",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "ALCOHOLIC DRINK",
                                          "isChargeable": true,
                                          "amenityType": "MEAL",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "NON ALCOHOLIC DRINK",
                                          "isChargeable": false,
                                          "amenityType": "MEAL",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      }
                                  ]
                              },
                              {
                                  "segmentId": "2",
                                  "cabin": "BUSINESS",
                                  "fareBasis": "IC3GLE",
                                  "brandedFare": "MN",
                                  "brandedFareLabel": "MINT",
                                  "class": "I",
                                  "includedCheckedBags": {
                                      "quantity": 2
                                  },
                                  "amenities": [
                                      {
                                          "description": "LIE FLAT BED",
                                          "isChargeable": false,
                                          "amenityType": "PRE_RESERVED_SEAT",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "EXTRA LEGROOM",
                                          "isChargeable": false,
                                          "amenityType": "PRE_RESERVED_SEAT",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "ADVANCE SEAT SELECTION",
                                          "isChargeable": false,
                                          "amenityType": "PRE_RESERVED_SEAT",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "SNACK",
                                          "isChargeable": false,
                                          "amenityType": "MEAL",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "ALCOHOLIC DRINK",
                                          "isChargeable": false,
                                          "amenityType": "MEAL",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "NON ALCOHOLIC DRINK",
                                          "isChargeable": false,
                                          "amenityType": "MEAL",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      },
                                      {
                                          "description": "MEAL",
                                          "isChargeable": false,
                                          "amenityType": "MEAL",
                                          "amenityProvider": {
                                              "name": "BrandedFare"
                                          }
                                      }
                                  ]
                              }
                          ]
                      }
                  ]
              }
              */
              
              let svcustProfile_newcustomer = {
                "customerId": -6,
                "addressId":-1
            }
             if(!valuesChild['svcustProfile']){
                valuesChild['svcustProfile'] = svcustProfile_newcustomer
             }
             /*svnov20 start*/
             //we need to save in db based on sessionid or jwttoken genereate
             //and get that
             /*
             let toffer = valuesChild
             if(toffer && toffer["travelerPricings"] && toffer["travelerPricings"] ){
                 let tars = toffer["travelerPricings"]
                 for(let m=0; m <  tars.length; m++){
                     delete tars[m].fareDetailsBySegment
                 }
             }
             */
            /*svnov20 start*/
              let svaluesChild = JSON.stringify(valuesChild)
              let size = svaluesChild.length
              console.log('********OCT25**************** SIZE OF  COOKIES  svcookoffer ', size)
   
              

            
              try{
                  /*
                console.log(localStorage)
                localStorage.setItem('svcookls', svaluesChild);
                cookies.set('svcook', svaluesChild, { path: '/' });
                */
                cookies.set('svcook', svaluesChild, { path: '/' });

              }catch(error){
                console.log('********Nov29****************  COOKIES ERROR UNABLE TO SAVE  svcookoffer START')
   
                   console.log(error)}
             

              let m_offer = cookies.get('svcook')
              console.log('********OCT25**************** TEST TO COOKIES SET svcookoffer START', m_offer)
              /*svdec2 start */
              let my_data_svtoffee ={
                "customerId": valuesChild['svcustProfile']['customerId'] ,
                "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
                "svcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
            } 
            my_data_svtoffee.svcook = svaluesChild
            console.log('********DEC4**************** expresseion sesion START ')
            
            let expsessid_svt_s =  cookies.get('svabodeclientguest')
            console.log(expsessid_svt_s);
            
            let m_svt = expsessid_svt_s
            if(m_svt != null){
                my_data_svtoffee['svt'] = m_svt
            }
            console.log('********DEC4**************** TEST TO COOKIES SET my_data_svtoffee ')
            console.log(my_data_svtoffee)
            console.log('********DEC4**************** expresseion sesion START ')
            
             this.props.saveUserOffer({'my_data_svtoffee' :my_data_svtoffee})
             
            /*svdec2 end*/
              
            const udob ={
                "svcid": -2,
                "flight_space_key":flight_space_key
            
            }

            _.delay(()=>{
                console.log('sv****calling delauy DEC3 START'  )
                const { flight_space_key} = udob
                let surl = `/inetcosmos/svredfly/${flight_space_key}`
                console.log(surl)
                console.log('sv****calling delauy DEC3 END' )
                history.push(`/inetcosmos/svredfly/${flight_space_key}`)
            }, 400, udob);

            // history.push(`/inetcosmos/svredfly/${flight_space_key}`)
  
          }else{
              console.log('********OCT25**************** FAILED TO COOKIES SET svcookoffer START')
   
          }
          

      }
    
    }

    constructor(props) {
        super(props)
        let me = this
        this.svofferMyFlyReservationSelectparent = this.svofferMyFlyReservationSelectparent.bind(me)
        this.svofferselectparent = this.svofferselectparent.bind(me)
        /*
        this.state = {  
           
            
            filters: {
                checkedParkingLabel:'Parking',
                checkedParking:true,
                disabledParking:false,

                checkedWifiLabel:'Wifi',
                checkedWifi:true,
                disabledWifi:false,

                checkedRestaurantLabel:'Restaurant',
                checkedRestaurant:true,
                disabledRestaurant:false,

                checkedPetfriendlyabel:'pet Friendlly',
                checkedPetfriendly:true,
                disabledPetfriendly:false,

                checkedRoomserviceLabel:'Room Service',
                checkedRoomservice:true,
                disabledRoomservice:false,

                checkedFrontdeskLabel:'24 Hours Front Desk',
                checkedFrontdesk:true,
                disabledFrontdesk:false,

                checkedFitnessLabel:'Fitness Center',
                checkedFitness:true,
                disabledFitness:false,

                checkedNonsmokingLabel:'Non Smoking',
                checkedNonsmoking:true,
                disabledNonsmoking:false,

                checkedShuttleLabel:'Airport Shuttle',
                checkedShuttle:true,
                disabledShuttle:false,

                checkedFamilyroomsLabel:'Family Room',
                checkedFamilyrooms:true,
                disabledFamilyrooms:false,

                checkedSpaLabel:'Spa',
                checkedSpa:true,
                disabledSpa:false,

                checkedEvchargingLabel:'Electric Vehicle(EV) Charging',
                checkedEvcharging:true,
                disabledEvcharging:false,

                checkedWheelchairLabel:'Wheel Chair Accessibility',
                checkedWheelchair:true,
                disabledFWheelchair:false



            }
            
        }
        
        this.onChangeCbParking = this.onChangeCbParking.bind(me)
        */
        this.getAppDetails = this.getAppDetails.bind(this)
        this.getAppDetailsMyReservation = this.getAppDetailsMyReservation.bind(this)
        
        this.getMyHtml = this.getMyHtml.bind(this)
        this.getReserveHtmlButton = this.getReserveHtmlButton.bind(this)
        this.svsojourns = []
        this.title = 'PROD-NON-PROD Symmetry'
        this.getHotelAmenityList = this.getHotelAmenityList.bind(me)
        this.getChildContainers = this.getChildContainers.bind(me)
        //this.getChildContainersList = this.getChildContainersList.bind(me)
        this.getChildContainersList_amb = this.getChildContainersList_amb.bind(me)
        this.getBoardBodyContainer_amb = this.getBoardBodyContainer_amb.bind(me)
        this.getBedroomDetails = this.getBedroomDetails.bind(me)
        this.deleteTaskCurryParams  = this.deleteTaskCurryParams.bind(this)

        this.starBody = this.starBody.bind(this)
    }
    starBody(o){
        let svrstars = {
            "sv_rating_no":o.avg_stars_rating ? o.avg_stars_rating : 5  ,
            "color": "#e8a01899"
        }
        svrstars['sv_rating_no'] =4
        return(<TerrainStars svrstars={svrstars} ></TerrainStars>)

    }
   
    deleteTaskCurryParams = (param1, ctx)=>(event)=>{
        console.log(param1)
		let me = ctx
		me.currentSelection = param1.sojourncode
		console.log('sv delete task curry')
		console.log(param1.sojourncode)
		//me.props.svWrappedDeleteTaskActionCreator(param1.id)
	}
    getBedroomDetails = (s, ctx)=>(event)=>{

        const det = 'Ssandara Queen Room with '
        console.log('sv**currryy' + s)
        s = (s? s : '2')
        if (s =='4'){
            return  det + '4' + 'Rooms'
        }else{
            return  det + s + 'Rooms'
        }

    }
    getAppDetailsMyReservation(paramQSpaceId, svcustProfile){
        console.log('caall getAppDetailsMyReservation', paramQSpaceId,svcustProfile)
        let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
       // this.props.flyAndImagesSV(sojPostRq)
       this.props.flyCountryCodeSV(sojPostRq)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    getAppDetails(paramQ){
        
       // this.props.getSoDetails("mancreek")

      // this.props.flyAndImagesSV("mancreek")

      let sojPostRq = {
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
            "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "Asia/Kolkata",
            "OP": "range"
        },
         "org": "09A",
        "dst":"ADQ"
    }
   // this.props.flyAndImagesSV(sojPostRq)
   this.props.flyCountryCodeSV(sojPostRq)
       
       
    }
    componentWillMount()	{
		console.log('=---json')
        const { cookies } = this.props;
       
        if(cookies){
            let sguestchild = uuidv4()
            cookies.set('svabodeclientguest', sguestchild, { path: '/' });
        }
        
		let svsojourns = [
        
            {
                "name": "3",
                "id": 3,
                "selected": false,
                "age": 32,
                "species": "Stego"
            },
            {
                "name": "4",
                "id": 4,
                "selected": false,
                "age": 13,
                "species": "T. Rex"
            }
        ]
        console.log('**sv sohourns got from service ********')
		console.log(svsojourns)
		
//sv step1 dipatch action  dispatch is warpper with actiobcreateer by redux
//sv step2 reduce gives you new state that is available as props to render method
    			console.log('sv--tasks')
    			this.svsojourns = svsojourns
    			var ar = svsojourns;
			//this.props.svWrappedfetchSVESSearchActionCreator(ar)
            this.getAppDetails('mancreek')
			
			
	

	}

     getMyHtml(){
        let ar = this.state.my_data;
        
        console.log(this.state)
        console.log(ar);
        const my_data = this.state.my_data;
        return my_data.map(o => {
            console.log(o)
            return (<li>{o.name}</li>)
        });
    }

    getReserveHtmlButton(o,customerId){
        if(customerId > 0){
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myflyreservationsSV/${customerId}/flyressvCustNew/${o.space_key}`}> ExistinggCustomerFlightReserve  </Link></Button>)
            

        }else{

            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svessearch/svredbook/${o.space_key}`}> Reserve  </Link></Button>)
            
        }
        
    }
    getHotelAmenityList(ar){
        
        
        ar = ar || []
       return ar.map( (v, idx)=>{
           if(v.toLocaleLowerCase() == "swimming beach"){
            return (<span style={{fontSize: "14px"}} > <HeartIcon style={{ color: 'hotpink' }} /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        
           }else if(v.toLocaleLowerCase() == "tennis"){  
            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122196' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        

           }else if(v.toLocaleLowerCase() == "water"){  
            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#522f96' }} type="video-camera" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        

           }else{

            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        
           }
          })
       


    }
   
    getChildContainers() {
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        if (this.props.data && (this.props.data.length > 0)) {
            data = this.props.data
        }
        if (this.props.sojourns && (this.props.sojourns.length > 0)) {
            sojourns = this.props.sojourns

            console.log('sv******************this.props')
            console.log(this.props)

            console.log('sv******************this.props....')
        }
        if (this.props.my_data && (this.props.my_data.length > 0)) {
            my_data = this.props.my_data
        }
        /*
        if (this.props.loading) {
            return <Loader type='spinner' />
        } else if (this.props.error) {
            return <ErrorWidget error={this.props.error} />
        }
        */
        return (
            <div>


<div className="box-outer-listhotels">
    <div className="box-left-listhotels">
        <p>
            
            <text className="f24" >SV Cambria Hotel Oraland </text>
            <span className="f12" >Oralndo  <text>Shown On map</text> <text>4  iles away</text></span>
           
        </p>
       
    </div>

    <div className="box-right-listhotels">
      
        <p>
            <text   className="f19">Excellent </text>
            <text className="f12 d-block"  >12345 reviews </text>
            <span className="f12 sv-hide" >Oralndo  <text>Shown On map</text> <text>4  iles away</text></span>
            
        </p>
       
        
    </div>
</div>


<div className="box-outer-listhotels">
    <div className="box-left-listhotels">
        <p>
            
            <text className="f19"> Standard Queen Room With two Queen Rooms & shower </text>
            <text className="f12"> 2 Queen Beds </text>
            
        </p>

    </div>

    <div className="box-right-listhotels">
      
        <p>
            <text   className="f19">1night, 2days </text>
            <text   className="f22 d-block">$116 </text>
           
            
        </p>
        
    </div>
</div>
<div className="box-outer-listhotels">
    <div className="box-left-listhotels">
        <p>
            
            <text className="f19"> Only 8  Rooms left </text>
           
            
        </p>

    </div>

    <div className="box-right-listhotels">
      
        <p>
           
           
            
        </p>
        
    </div>
</div>
            
            </div>
           
            
            )
    }

   
    
    render() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title, sojourns} = this
       
/*
        const getMyHtml = () => {
            return this.props.sojourns.map(o => {
                console.log(o)
                return (<li>{o.sojourncode}</li>)
            });
        }
    
        const getMyData = () => {
            console.log("dino data");
            console.log(sojourns);
            console.log("end");
            return arso;
        }
        */
/*
        const { cookies } = this.props;
        if(cookies){
            let svcookoffer_o =cookies.get('svcook')
            console.log('********OCT25**************** COOKIES SET svcookoffer START')
    
            if(svcookoffer_o ){
                let svcookoffer_val = {
                    "type": "flight-offer",
                    "id": "2",
                    "source": "GDS",
                    "instantTicketingRequired": false,
                    "nonHomogeneous": false,
                    "oneWay": false,
                    "isUpsellOffer": false,
                    "lastTicketingDate": "2024-10-27",
                    "lastTicketingDateTime": "2024-10-27",
                    "numberOfBookableSeats": 3,
                    "itineraries": [
                        {
                            "duration": "PT9H15M",
                            "segments": [
                                {
                                    "departure": {
                                        "iataCode": "JFK",
                                        "terminal": "5",
                                        "at": "2024-11-01T12:10:00"
                                    },
                                    "arrival": {
                                        "iataCode": "BOS",
                                        "terminal": "C",
                                        "at": "2024-11-01T13:22:00"
                                    },
                                    "carrierCode": "B6",
                                    "number": "1318",
                                    "aircraft": {
                                        "code": "E90"
                                    },
                                    "operating": {
                                        "carrierCode": "B6"
                                    },
                                    "duration": "PT1H12M",
                                    "id": "1",
                                    "numberOfStops": 0,
                                    "blacklistedInEU": false
                                },
                                {
                                    "departure": {
                                        "iataCode": "BOS",
                                        "terminal": "C",
                                        "at": "2024-11-01T15:00:00"
                                    },
                                    "arrival": {
                                        "iataCode": "LAX",
                                        "terminal": "5",
                                        "at": "2024-11-01T18:25:00"
                                    },
                                    "carrierCode": "B6",
                                    "number": "387",
                                    "aircraft": {
                                        "code": "32S"
                                    },
                                    "operating": {
                                        "carrierCode": "B6"
                                    },
                                    "duration": "PT6H25M",
                                    "id": "2",
                                    "numberOfStops": 0,
                                    "blacklistedInEU": false
                                }
                            ]
                        }
                    ],
                    "price": {
                        "currency": "USD",
                        "total": "950.87",
                        "base": "861.67",
                        "fees": [
                            {
                                "amount": "0.00",
                                "type": "SUPPLIER"
                            },
                            {
                                "amount": "0.00",
                                "type": "TICKETING"
                            }
                        ],
                        "grandTotal": "950.87"
                    },
                    "pricingOptions": {
                        "fareType": [
                            "PUBLISHED"
                        ],
                        "includedCheckedBagsOnly": true
                    },
                    "validatingAirlineCodes": [
                        "B6"
                    ],
                    "travelerPricings": [
                        {
                            "travelerId": "1",
                            "fareOption": "STANDARD",
                            "travelerType": "ADULT",
                            "price": {
                                "currency": "USD",
                                "total": "950.87",
                                "base": "861.67"
                            },
                            "fareDetailsBySegment": [
                                {
                                    "segmentId": "1",
                                    "cabin": "ECONOMY",
                                    "fareBasis": "MI3AUEY5",
                                    "brandedFare": "AN",
                                    "brandedFareLabel": "BLUE",
                                    "class": "M",
                                    "includedCheckedBags": {
                                        "quantity": 2
                                    },
                                    "amenities": [
                                        {
                                            "description": "CHECKED BAG FIRST",
                                            "isChargeable": true,
                                            "amenityType": "BAGGAGE",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "CHECKED BAG SECOND",
                                            "isChargeable": true,
                                            "amenityType": "BAGGAGE",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "EXTRA LEGROOM",
                                            "isChargeable": true,
                                            "amenityType": "PRE_RESERVED_SEAT",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "ADVANCE SEAT SELECTION",
                                            "isChargeable": false,
                                            "amenityType": "PRE_RESERVED_SEAT",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "SNACK",
                                            "isChargeable": false,
                                            "amenityType": "MEAL",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "ALCOHOLIC DRINK",
                                            "isChargeable": true,
                                            "amenityType": "MEAL",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "NON ALCOHOLIC DRINK",
                                            "isChargeable": false,
                                            "amenityType": "MEAL",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "segmentId": "2",
                                    "cabin": "BUSINESS",
                                    "fareBasis": "IC3GLE",
                                    "brandedFare": "MN",
                                    "brandedFareLabel": "MINT",
                                    "class": "I",
                                    "includedCheckedBags": {
                                        "quantity": 2
                                    },
                                    "amenities": [
                                        {
                                            "description": "LIE FLAT BED",
                                            "isChargeable": false,
                                            "amenityType": "PRE_RESERVED_SEAT",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "EXTRA LEGROOM",
                                            "isChargeable": false,
                                            "amenityType": "PRE_RESERVED_SEAT",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "ADVANCE SEAT SELECTION",
                                            "isChargeable": false,
                                            "amenityType": "PRE_RESERVED_SEAT",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "SNACK",
                                            "isChargeable": false,
                                            "amenityType": "MEAL",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "ALCOHOLIC DRINK",
                                            "isChargeable": false,
                                            "amenityType": "MEAL",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "NON ALCOHOLIC DRINK",
                                            "isChargeable": false,
                                            "amenityType": "MEAL",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        },
                                        {
                                            "description": "MEAL",
                                            "isChargeable": false,
                                            "amenityType": "MEAL",
                                            "amenityProvider": {
                                                "name": "BrandedFare"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
                cookies.set('svcook', svcookoffer_val, { path: '/' });
    
            }else{
                console.log('********OCT25**************** FAILED TO COOKIES SET svcookoffer START')
     
            }
            

        }
      
        */

          return (

            
            <div className="col-md-12">

    
                {/*  
                <MotelTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersList()}></MotelTerrain>
 
                */}
                <MotelTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersList_amb()}></MotelTerrain>
            </div>
        )
        
    }
/*
    getChildContainersList() {
        const {svofferselectparent, svofferMyFlyReservationSelectparent} = this
      
       
               const size = 'small'
                const legend = [{
                    "sojourncode": "100",
                    "vernacularcode": "EN",
                    "sojourn_name": "253 Mancreek Resort"
                },
                {
                    "sojourncode": "101",
                    "vernacularcode": "EN",
                    "sojourn_name": "253 John Resort"
                }]
                let customerId = -1
                const {dataProfile, svcustProfile} = this.props
                //customerId i string 
                if(this.props.svcustProfile && this.props.svcustProfile.customerId){
                    if(typeof(this.props.svcustProfile.customerId) == "string"){
                        customerId = parseInt(svcustProfile.customerId )
                    }else{
                        customerId = svcustProfile.customerId
                    }
                    
                    console.log('myreservationSpace')
                    }else{
                     console.log('internet userSpace')
                    }
                let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
                if (this.props.svflysearch.data && (this.props.svflysearch.data.length > 0)) {
                    data = this.props.svflysearch.data
                }
                if (this.props.svflysearch.sojourns && (this.props.svflysearch.sojourns.length > 0)) {
                    sojourns = this.props.svflysearch.sojourns
        
                    console.log('sv******************this.props')
                    console.log(this.props)
        
                    console.log('sv******************this.props....')
                }
                let my_data_tmp = null;
                if (this.props.svflysearch && this.props.svflysearch.my_data && (this.props.svflysearch.my_data.length > 0)) {
                    my_data_tmp = this.props.svflysearch.my_data
                }else if(this.props.my_data && (this.props.my_data.length > 0)){
                    my_data_tmp = this.props.my_data
                }else{
                    my_data_tmp = []
                }
                for(let i=0; i < my_data_tmp.length ; i++ ){
                    let r = my_data_tmp[i]
                    let my_ob = _.clone(r)
                    my_data.push(my_ob)
                    my_ob['svcustProfile'] = this.props.svcustProfile
                    my_ob['customerId'] = customerId
                }
        
                const {svessearch, locationDataView} = this.props
                console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master start')
                console.log(this.props)
                console.log('sv$$$$$$$$$$$$$$$$$$*****svcustProfile added')
                console.log(my_data)
                console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master end')
               
               let testimonyO = {
                avg_stars_rating :5
               }
                return (
                    <div className="svr-det-pageWrapper">
                    <header className="svr-header1">
                    <h1><span><text style={{color:'#f0d8a9'}}>Choose Your Flight  </text><Link to={`/svlogin`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
                    </header>
                    <FlySearchBarBusCom />
                   
                   
                
                
                    <div className="svr-spacelist-contentWrapper">
                        <article className="main-listhotels">
                        <div className="svr-spacelist-box-row1">
<div className="o-container-flist">
<div className="o-box-flist-b1">
        <span className="o-span">
           
                
                       
                    
                    <span>
                    <p className="m-para-text">
                    <span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="dashboard" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>8:30 am</text><Icon type="line" /><text style={{ color: '#122196' }} style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>4:58 pm</text></span>
                        
                        <text style={{fontSize:'14px'}} className="svr-hotel-room d-block" >  San Jose2 (SJC) - Austin (AUS) </text>
                        <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ca61a1', opacity:'0.9', fontSize:'16px' }} type="account-book" theme="filled" /><text style={{paddingLeft: "10px", color:'#898995'}}>Delta operated by SV DBA Deltaz Connection</text></span>

                       </p>
                    </span>
                
            

           
        </span>
    </div>
    <div className="o-box-flist">
        <span className="o-span">
            
                    <p className="m-para-text">
                    <span style={{fontSize: "14px"}} > <text style={{fontSize:'14px',color:'#768999'}} >6h 28m </text><Icon style={{paddingLeft: "10px", color: 'rgb(126, 181, 230)' , fontSize:'14px'}} type="cloud-upload"   /><text style={{fontSize:'14px',color:'#768999',paddingLeft: "10px"}} >2 Stop</text></span>
                        <text style={{fontSize:'14px'}} className="svr-hotel-room d-block"> 1h 42 m in DEN </text>
                        <text style={{fontSize:'12px',color:'#898995'}} className="f12  d-block"> United </text>
                    </p>
                
        </span>
    </div>
   
    <div className="o-box-flist">
        <span className="o-span">
           
                
               
                    <p className="m-para-text">
                    
                        <text style={{fontSize:'18px'}} className="svr-hotel-price d-block">$116 </text>
                        <text style={{fontSize:'14px'}} className="svr-hotel-stay d-block">SVIRound Trip per person</text>
                        <span style={{fontSize: "12px"}} > <Icon style={{ color: '#122196' }} type="gift"  /><text style={{paddingLeft: "10px",  fonrSize:'13px', color:'#898995'}}>Save $2.67 SVPromoClub </text></span>
                        <Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetcosmos/svredfly/1@4@1@ADQ`}> Fly Reserve  </Link></Button>
        
                    </p>
                
            
        </span>
    </div>
   
</div>
</div>
                            
                        {
                            
                                my_data.map(o => {
                                    let soj = o
                                    //convet keys of o to uppercase
                                    console.log('sv***soj**')
                                    console.log(soj)
                                    let priceInfo = {
                                        o:o,
                                        customerId:o.customerId
                                    }
                                    let reservekey = 'insvreview'
                                   
                                   
                                    let svr_fly = {
                                        "flight_space_key":soj["flight_space_key"]?soj["flight_space_key"]:"1@4@1@ADQ",
                                        "flight_time_hhmm": soj['flight_time_hhmm'] ? soj['flight_time_hhmm'] :"6h 31min",

                                        "flight_airline_num_stops": soj['flight_airline_num_stops'] ? soj['flight_airline_num_stops'] :3,
                                        "airlines_name": soj['airlines_name'] ? soj['airlines_name'] : "Delta Airlines",
                                        "airlines_name_iata": soj['airlines_name_iata'] ? soj['airlines_name_iata'] : "DL",
                                        "airlines_code_iata": soj['airlines_code_iata'] ? soj['airlines_code_iata'] : "2113",

                                        "flight_operated_by": soj['flight_operated_by'] ? soj['flight_operated_by'] : "Delta operated by SV DBA Deltaz Connection",
                                        "flight_operator_owned": soj['flight_operator_owned'] ? soj['flight_operator_owned'] : "Y",

                                        "flight_departure_time": soj['flight_departure_time'] ? soj['flight_departure_time'] : "06:30",
                                        "flight_arrival_time": soj['flight_arrival_time'] ? soj['flight_arrival_time'] : "7:30",
                                        "flight_arrival_daytime": soj['flight_arrival_daytime'] ? soj['flight_arrival_daytime'] : "AM",
                                        "flight_departure_daytime": soj['flight_departure_daytime'] ? soj['flight_departure_daytime'] : "PM",

                                        "origin_airport_code": soj['origin_airport_code'] ? soj['origin_airport_code'] : "SJC",
                                        "origincity": soj['origincity'] ? soj['origincity'] : "Sajn Jose",
                                        "dst_airport_code": soj['dst_airport_code'] ? soj['dst_airport_code'] : "AUS",
                                        "destcity": soj['destcity'] ? soj['destcity'] : "Austin",
                                        "airlines_name": soj['airlines_name'] ? soj['airlines_name'] : "Delta Airlines",
                                        

                                    }
                                    return (
                                        <div className="svr-spacelist-box-row1">
                                     
                                         <FlyLocationSVPriceListView priceInfo={priceInfo} svcustProfile={o.svcustProfile} reservekey={reservekey}  svrlocation={svr_fly}></FlyLocationSVPriceListView>
                                     
                                       
                                    </div>
                                        
                                    )
                                })
                            }
                           
                            
                        </article>
                
                       
                        <aside className="siberbar2">
                
                            <h3> Filter By</h3>
                            <SVFlyFacetBarBusCom  locationDataView={locationDataView} />
                           
                            <div className="svr-rating-content">
                                <p className="svr-hotel-rating" >Excelllent 5.0
                                </p>
                
                            </div>
                
                            <div className="svr-num-reviews-content">
                                <p>12,364 reviews
                                </p>
                
                            </div>
                            <div className="svr-review-author-comment-content">
                
                                <p>“The property has a great bar/restaurant in the lobby, which is good because there isn't much
                                    around
                                    there to choose from food wise.”
                                </p>
                                <p> Jane Ellison</p>
                            </div>
                
                            <div className="svr-fa-stars-content">
                                <p>
                                {this.starBody(testimonyO)}
                                </p>
                            </div>
                        </aside>
                
                    </div>
                
                
                
                
                    <br />
                
                
                </div>
                    
                    )
            }
*/
    /*svj17 start*/
    getChildContainersList_amb() {
       
        const {svofferselectparent, svofferMyFlyReservationSelectparent} = this
        console.log('sva21 ****flyboard*****, props')
        console.log(this.props)
        const {my_data_geo,svfly_esquery_data} = this.props.svflysearch
        /*
                const {
                checkedWifi, checkedRestaurant, checkedPetfriendly, checkedRoomservice, checkedFitness, checkedFrontdesk, checkedNonsmoking, checkedShuttle, checkedFamilyrooms, checkedSpa, checkedEvcharging, checkedWheelchair, checkedPool,
                disabledWifi, disabledRestaurant, disabledPetfriendly, disabledRoomservice, disabledFitness, disabledFrontdesk, disabledNonsmoking, disabledShuttle, disabledFamilyrooms, disabledSpa, disabledEvcharging, disabledFWheelchair, disabledPool,
                checkedWifiLabel, checkedRestaurantLabel, checkedPetfriendlyabel, checkedRoomserviceLabel, checkedFitnessLabel, checkedFrontdeskLabel, checkedNonsmokingLabel, checkedShuttleLabel, checkedFamilyroomsLabel, checkedSpaLabel, checkedEvchargingLabel, checkedWheelchairLabel, checkedPoolLabel,
                checkedParking,checkedParkingLabel,disabledParking
        
        
                } = this.state.filters
                */
               const size = 'small'
                const legend = [{
                    "sojourncode": "100",
                    "vernacularcode": "EN",
                    "sojourn_name": "253 Mancreek Resort"
                },
                {
                    "sojourncode": "101",
                    "vernacularcode": "EN",
                    "sojourn_name": "253 John Resort"
                }]
                let customerId = -1
                const {dataProfile, svcustProfile} = this.props
                //customerId i string 
                if(this.props.svcustProfile && this.props.svcustProfile.customerId){
                    if(typeof(this.props.svcustProfile.customerId) == "string"){
                        customerId = parseInt(svcustProfile.customerId )
                    }else{
                        customerId = svcustProfile.customerId
                    }
                    
                    console.log('myreservationSpace')
                    }else{
                     console.log('internet userSpace')
                    }
                let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
                if (this.props.svflysearch.data && (this.props.svflysearch.data.length > 0)) {
                    data = this.props.svflysearch.data
                }
                if (this.props.svflysearch.sojourns && (this.props.svflysearch.sojourns.length > 0)) {
                    sojourns = this.props.svflysearch.sojourns
        
                    console.log('sv******************this.props')
                    console.log(this.props)
        
                    console.log('sv******************this.props....')
                }
                let my_data_tmp = null;
                if (this.props.svflysearch && this.props.svflysearch.my_data && (this.props.svflysearch.my_data.length > 0)) {
                    my_data_tmp = this.props.svflysearch.my_data
                }else if(this.props.my_data && (this.props.my_data.length > 0)){
                    my_data_tmp = this.props.my_data
                }else{
                    my_data_tmp = []
                }
                for(let i=0; i < my_data_tmp.length ; i++ ){
                    let r = my_data_tmp[i]
                    let my_ob = _.clone(r)
                    my_data.push(my_ob)
                    my_ob['svcustProfile'] = this.props.svcustProfile
                    my_ob['customerId'] = customerId
                }
        
                const {svessearch, locationDataView} = this.props
                console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master start')
                console.log(this.props)
                console.log('sv$$$$$$$$$$$$$$$$$$*****svcustProfile added')
                console.log(my_data)
                console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master end')
                /*
                if (this.props.loading) {
                    return <Loader type='spinner' />
                } else if (this.props.error) {
                    return <ErrorWidget error={this.props.error} />
                }
                */
               let testimonyO = {
                avg_stars_rating :5
               }
                return (
                    <div className="svr-det-pageWrapper">
                    <header className="svr-header1">
                    <h1><span><text style={{color:'#f0d8a9'}}>Choose Your Flight  </text><Link to={`/myaccountSV/${customerId}/svprofile`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
                    </header>
                    <FlySearchBarBusCom my_data_geo={my_data_geo} />
                   
                   
                
                
                    <div className="svr-spacelist-contentWrapper">
                        <article className="main-listhotels">
                        <div className="svr-spacelist-box-row1">
<div className="o-container-flist">
<div className="o-box-flist-b1">
        <span className="o-span">
           
                
                       
                    
                    <span>
                    <p className="m-para-text">
                    <span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="dashboard" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>8:30 am</text><Icon type="line" /><text style={{ color: '#122196' }} style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>4:58 pm</text></span>
                        
                        <text style={{fontSize:'14px'}} className="svr-hotel-room d-block" >  San Jose (SJC) - Austin (AUS) </text>
                        <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ca61a1', opacity:'0.9', fontSize:'16px' }} type="account-book" theme="filled" /><text style={{paddingLeft: "10px", color:'#898995'}}>Delta Airlines (Sponsored Promotion to Travel Club)</text></span>

                       </p>
                    </span>
                
            

           
        </span>
    </div>
    <div className="o-box-flist">
        <span className="o-span">
            
                    <p className="m-para-text">
                    <span style={{fontSize: "14px"}} > <text style={{fontSize:'14px',color:'#768999'}} >6h 28m </text><Icon style={{paddingLeft: "10px", color: 'rgb(126, 181, 230)' , fontSize:'14px'}} type="cloud-upload"   /><text style={{fontSize:'14px',color:'#768999',paddingLeft: "10px"}} >2 Stop</text></span>
                        <text style={{fontSize:'14px'}} className="svr-hotel-room d-block"> 1h 42 m in DEN </text>
                        <text style={{fontSize:'12px',color:'#898995'}} className="f12  d-block"> Delta </text>
                    </p>
                
        </span>
    </div>
   
    <div className="o-box-flist">
        <span className="o-span">
           
                
               
                    <p className="m-para-text">
                    
                        <text style={{fontSize:'18px'}} className="svr-hotel-price d-block">$116 </text>
                        <text style={{fontSize:'14px'}} className="svr-hotel-stay d-block">Round Trip per person</text>
                        <span style={{fontSize: "12px"}} > <Icon style={{ color: '#122196' }} type="gift"  /><text style={{paddingLeft: "10px",  fonrSize:'13px', color:'#898995'}}>Save $2.67 SVPromoClub </text></span>
                        <Button  disabled={promoDisabled} style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svflysearch/svredfly/1@4@1@ADQ`}> Fly Reserve  </Link></Button>
        
                    </p>
                
            
        </span>
    </div>
   
</div>
</div>
                            
            {this. getBoardBodyContainer_amb(svfly_esquery_data,my_data,svofferMyFlyReservationSelectparent,svofferselectparent)}
                            
                        </article>
                
                       
                        <aside className="siberbar2">
                
                            <h2 style={{fontSize:'18px'}}> Filter By </h2>
                            <SVFlyFacetBarBusCom  locationDataView={locationDataView} />
                            {/*  */}
                            <div className="svr-rating-content">
                                <p className="svr-hotel-rating" >Excelllent 4.0
                                </p>
                
                            </div>
                
                            <div className="svr-num-reviews-content">
                                <p>12,364 reviews
                                </p>
                
                            </div>
                            <div className="svr-review-author-comment-content">
                
                                <p>“The destination has a great bar/restaurant in the lobby, which is good because there isn't much
                                    around
                                    there to choose from food wise.”
                                </p>
                                <p> Jane Ellison</p>
                            </div>
                
                            <div className="svr-fa-stars-content">
                                <p>
                                {this.starBody(testimonyO)}
                                </p>
                            </div>
                        </aside>
                
                    </div>
                
                
                
                
                    <br />
                
                
                </div>
                    
                    )
            }
    
            getBoardBodyContainer_amb(svfly_esquery_data,my_data,svofferMyFlyReservationSelectparent,svofferselectparent){
                if(this.props.svflysearch.error){
                    console.log('sv**container ger errob')
                    let errob = {
                        "timestamp": "2015-08-23T02:27:18.038+0000",
                        "status": 500,
                        "error": "FlyServer Error",
                        "message": "No Resulst Found.Please refinse search and try again",
                        "path": "/kk/svaddressDetailPost"
                    }
                    let today_dt = new Date()
                    errob["timestamp"] = today_dt
                   return (
                     <div >
                        
                         <div style={{paddingTop:'10px'}}>
                           <ErrorCom  closecbParent={this.closecbParent} errob={errob} ></ErrorCom>
                         </div>
                        
                        
                      </div>   
                        )
           
                  }else if(this.props.svflysearch.loading ){
                   return (
           
                     <div >
                         {/* 
                        <h3>Spinner*****</h3>
                         */}
                     <div style={{paddingTop:'10px'}}>
                    
        
                       <SVAbodeSpinner />
                     </div>
                    
                    
                  </div>   
           
                   
                         )
           
                  }
                /*
                  if (this.props.loading) {
            return <Loader type='spinner' />
        } else if (this.props.error) {
            return <ErrorWidget error={this.props.error} />
        }
        */
        return (
                                 
<FlySearchBoardBody svfly_esquery_data={svfly_esquery_data} my_data={my_data} svofferMyFlyReservationSelectparent={svofferMyFlyReservationSelectparent} svofferselectparent={svofferselectparent} />
  
        )
            }
    /*svj17 end*/
}

export default FlySearchBoardContainer